import { IntegrationInterfaceCompanyRequest } from "@/main/models/request";
import { IntegrationInterfaceCompanyResponse } from "@/main/models/response";
import { AxiosResponse } from "axios";
import { IIntegrationInterfaceCompanyApi, api } from "../base";
import { PaginationResponse } from "@/main/models/common/paginationResponse";

const baseRoute: string = "Integration_IntegrationInterface_Company";

export class IntegrationInterfaceCompanyApi extends IIntegrationInterfaceCompanyApi {
	getSearchGrid(
		request: IntegrationInterfaceCompanyRequest,
	): Promise<AxiosResponse<PaginationResponse<IntegrationInterfaceCompanyResponse[]>, any>> {
		return api.get(`${baseRoute}/`, { params: request });
	}
}
